module.exports = __webpack_public_path__ + "img/1993_L.9c880202.png";